import { db } from '@/main'

export const Authenticable = {
  methods: {
    welcomed( acct ) {
      return acct && acct.username && acct.phone && acct.zip && acct.gender && acct.dob && acct.email
    },

    accountify( doc ) {
      db.collection('accounts').doc( doc.user.uid ).set({
        user_id: doc.user.uid,
        email: doc.user.email || this.email || '',
        phone: doc.user.phoneNumber || this.phone || '',
        name: this.name || '',
        locale:  this.$i18n ? this.$i18n.locale : localStorage.getItem('locale'),
        merchant: false,
        referral: this.referral || false,
        tokens: {}
      }, {merge: true} ).then( () =>
        this.$binding( 'account', db.collection( 'accounts' ).doc( doc.user.uid ) ).then( doc =>
          this.$router.push({ name: 'onboarding' })
        )
      )

      if ( this.$route.params.id ) {
        db.collection( 'customers' ).doc( this.$route.params.id ).update({
          account_id: doc.user.uid,
          invitation: { invited: true, joined: true }
        })

        db.collection( 'favorites' ).doc( `${doc.user.uid}->${this.referral.id}` ).set({
          account_id: doc.user.uid,
          business_id: this.referral.id
        })
      }
    }
  }
}
